import { combineReducers, Reducer } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { CombinedStateType } from '../types';
import accountReducer from './accountReducer';
import dashboardReducer from './dashboardReducer';

const rootReducer: Reducer<CombinedStateType> = combineReducers({
  account: accountReducer,
  dashboard: dashboardReducer,
  form: formReducer,
});

export default rootReducer;
